import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import { localStorageStrategy, persistState } from '@ngneat/elf-persist-state';
import { Observable, Subject } from 'rxjs';

import { CartProps } from './interfaces/cart-props.model';
import { SimpleCartItem } from './interfaces/simple-cart-item.model';

const store = createStore(
  { name: 'cart' },
  withProps<CartProps>({ cartCount: 0, simpleItems: [] })
);

persistState(store, {
  key: 'cart-shop-state',
  storage: localStorageStrategy,
});

@Injectable({ providedIn: 'root' })
export class CartRepository {
  cartCount$ = store.pipe(select((state) => state.cartCount));
  simpleItems$ = store.pipe(select((state) => state.simpleItems));

  public cartCleared$: Observable<void>;
  private _cartCleared: Subject<void>;

  constructor() {
    this._cartCleared = new Subject<void>();
    this.cartCleared$ = this._cartCleared.asObservable();
  }

  triggerCartCleared() {
    this._cartCleared.next();
  }

  cartCount() {
    return store.getValue().cartCount;
  }

  simpleItems() {
    return store.getValue().simpleItems;
  }

  updateCartCount(cartCount: number) {
    store.update((state) => ({
      ...state,
      cartCount,
    }));
  }

  updateSimpleItems(simpleItems: SimpleCartItem[]) {
    store.update((state) => ({
      ...state,
      simpleItems,
    }));
  }
}
